import(/* webpackMode: "eager" */ "/codebuild/output/src804756364/src/widertalk-app-web/app/team/page.tsx");
